var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    Display other content for the following "+_vm._s(_vm.languageLabel)+": "+_vm._s(_vm.summary)+".\n")])}
var staticRenderFns = []

export { render, staticRenderFns }